{
    "ServiceMessages_Timeline_Title": "Messages de service et de maintenance",
    "NAME": "ServiceMessagesLanguage"
}